import fetch from "../../assets/js/fetch";
import _com from "../../assets/js/common";
import { unJsonp } from "../../assets/js/http";
import jsonp from "../../assets/js/http";
import { set } from "vue/types/umd";

const state = {
	RecommendGoods: {},
	lastRecommend: "",
	goodsList: [],
	hotGoodList: [],
	InsuranceGoods: [],
	coupons: [],
	auto_coupons: [],
	play_back_flag: '',
	patch_info: {},
	luck: {
		winners: [],
	},
	condition: '',
	luckHistory: {},
	cardAct: {},
	cardAllData: {},
	cardListData:{
		cardList: [],
		cardActIndex: 0,
	},
	luckCardAct:{},
	luckCardAllData:{
		actNum:0,
		count : 0,
		time : 0,
		showPop:false,
		showListPop:false,
		updateListPop:false,
	},
	isShowPrize: false,
	isShowPrizeHistory: false,
	isShowPhoneHint: false,
	isCardShow: false,
	roomData: {},
	opcRefreshData: {},
	follow: {},
	toLiveInfo: true,
	blessingInfo: null,
	bessingArr: [],//福袋中奖名单
	goodsMaterial: [],//录播商品素材切片
	yshLottery: '' // 中奖名单
};

const getters = {
	getYshLottery() {
		return state.yshLottery
	},
	getCondition(state: any) {
		return state.condition;
	},
	getHotGoodList(state: any) {
		return state.hotGoodList;
	},
	getRecommend(state: any) {
		return state.RecommendGoods;
	},
	getGoodsList(state: any) {
		if (state.InsuranceGoods.length) {
			return state.InsuranceGoods;
		}
		else {
			return state.goodsList;
		}
	},
	getLuck(state: any) {
		return state.luck;
	},
	getBessingList(state: any) {
		return state.bessingArr;
	},
	getLuckHistory(state: any) {
		return state.luckHistory;
	},
	getCardAct(state: any) {
		return state.cardAct;
	},
	getLuckCardAct(state: any) {
		return state.luckCardAct;
	},
	getIsShowPrize(state: any) {
		return state.isShowPrize;
	},
	getCardListData(state: any) {
		return state.cardListData;
	},
	getIsShowPrizeHistory(state: any) {
		return state.isShowPrizeHistory;
	},
	getIsShowPhoneHint(state: any) {
		return state.isShowPhoneHint;
	},
	getIsCardShow(state: any) {
		return state.isCardShow;
	},
	getRoomDetail(state: any) {
		return state.roomData;
	},
	getCoupons(state: any) {
		return state.coupons;
	},
	getPlayBackFlag(state: any) {
		return state.play_back_flag;
	},
	getPatchInfo(state: any) {
		return state.patch_info
	},
	getAutoCoupons(state: any) {
		return state.auto_coupons;
	},
	getOpcRefreshData() {
		return state.opcRefreshData;
	},
	getFollow() {
		return state.follow
	},
	getBlessing() {
		return state.blessingInfo
	},
	getGoodsMaterial() {
		return state.goodsMaterial
	},
	getCardAllData() {
		return state.cardAllData
	},
	getLuckCardAllData() {
		return state.luckCardAllData
	}
};

const actions = {
	getInsuranceAsync(context: any, roomNumber: string) {
		//获取推荐位假数据(后期删除)
		let url = "https://search" + process.env.VUE_APP_URI_DOMAIN + "/api/recommend?sectionKeys=broadcast-Insurance&restype=2002";
		unJsonp(url, {},).then((res: any) => {
			res = res.body["broadcast-Insurance"];
			if (res[0] && res[0].title == roomNumber) {
				context.commit('setInsurance', eval(JSON.parse(res[0].customAttribute).goodsList));
			}
		});

	},
	setInsuranceAsync(context: any, value: any) {
		context.commit('setInsurance', value);
	},

	getRecommendAsync(context: any, data: any) {
		let domain = process.env.VUE_APP_URI_CDNDOMAIN;
		if (data.source == 'uzg') {
			domain = '//pub' + process.env.VUE_APP_URI_DOMAIN;
		}
		let url = `${domain}/ulelivebarrage/api/v1/room/static/refresh/${data.roomNumber}/${Math.floor(new Date().getTime() / 10000)}/refresh`;
		jsonp(url, { jsonpcallback: "refresh" }).then((data: any) => {
			if (data) {
				data.goods = data.goods || [];
				data.goods = data.goods.sort((a: any, b: any) => {
					return a.listAsc > b.listAsc ? 1 : -1;
				});
				let urlData = new URL(location.href)
				if (data.product_id || location.href.includes('toSeckillLive')) {
					let liveListId = urlData.searchParams.get('liveListId')
					for (let i = 0; i < data.goods.length; i++) {
						if (liveListId && state.toLiveInfo) {
							if (data.goods[i].listId == liveListId) {
								data.goods[i].isRepeat = true;
								context.commit("setRecommendGoods", data.goods[i]);
								data.goods[i].isRepeat = true;
								sessionStorage.setItem('toSeckillLiveData','1')
								setTimeout(() => {
									state.toLiveInfo = false
								}, 30000);
							} else {
								data.goods[i].isRepeat = false;
							}
						} else {
							if (data.product_id == data.goods[i].listId) {
								// if (data.product_id != state.lastRecommend ) {
								data.goods[i].isRepeat = true;
								// } else {
								// 	data.goods[i].isRepeat = false;
								// }
								sessionStorage.setItem('toSeckillLiveData','2')
								// (<any>state.lastRecommend) = data.product_id;
								context.commit("setRecommendGoods", data.goods[i]);
							} else {
								data.goods[i].isRepeat = false;
							}
						}
					}
					//}
				} else {
					context.commit("setRecommendGoods", {});
				}
				context.commit("setGoodsList", data.goods);
				context.commit("setHotGoodList", data.hot_good_list);   // 设置爆款商品排序
				if (data.luck && data.luck.id) {
					if (data.luck_v2.source_type && data.luck_v2.source_type == 5) {
						data.luck.source_type = data.luck_v2.source_type == 5;
					}
					context.commit("setLuck", data.luck);
				}
				if (data.blessing_bag_info && data.blessing_bag_info.blessing_bag_setting && data.blessing_bag_info.blessing_bag_setting.winners) {
					context.commit("setBessing", data.blessing_bag_info.blessing_bag_setting.winners);
				}
				// if(data.luck_v2.source_type && data.luck_v2.source_type==5){
				// 	//source_type==5大型促销抽奖，与普通抽奖公用一个弹框
				// 	context.commit("setLuck", data.luck_v2);
				// }else{
				// 	//设置中奖记录
				// 	context.commit("setLuckHistory", data.luck_v2);
				// }
				context.commit("setCondition", data.blessing_bag_info.blessing_bag_setting.condition);
				context.commit("setLuckHistory", data.luck_v2);
				context.commit("setCardAct", data.card_act);
				context.commit("setLuckyCardAct", data.lucky_card_act);
				context.commit("setRoomDetail", data);
				context.commit("setPlayBackFlag", data.play_back_flag);
				context.commit("setFollow", data);
				context.commit("setBlessing", data);
				context.commit("setYshLottery", data.ulife_luck_info);
			}
		})
	},
	getGoodsMaterialAsync(context: any, data: any) {
		let callback = "getGoodsMaterial"
		let url = `//ustatic${process.env.VUE_APP_URI_ULECDNDOMAIN}/live/tv/static/luboRoom/materialGoods/${data.id}/${Math.floor(new Date().getTime() / 5000)}/${callback}`
		jsonp(url, {
			jsonp: callback,
			jsonpcallback: callback
		}).then(
			(data: any) => {
				context.commit("setGoodsMaterial", data || []);
			},
			(data: any) => {

			}
		);
	},
	getUserCardAsync(context:any,params:any) { //获取用户集卡数据
		let callback = "getUserCard"
		let url = `//service${process.env.VUE_APP_URI_DOMAIN}/appact/goldenEgg/queryUserCollectCards?cardActivityNo=${params.cardActivityNo}`
		return new Promise((resolve, reject) => {
			jsonp(url, {
				jsonp: "jsoncallback",
				jsoncallback: callback,
			}).then((data: any) => {
				if (data.code == '0000') {
					let datas = data.content
					let current = {}
					let cardNum = {
						num: 0,
						totalNum: 0,
						conflate:0
					}
					datas.cardInfos.forEach((card:any) => {
						if (card.cardType!=3) {
							if (card.totalNums>0) {
								cardNum.num += 1
							}
							cardNum.totalNum += 1
						} else if(card.totalNums > 0){
							cardNum.conflate += 1
						}
						if (params.current && card.cardNo == params.current.cardNo) {//当前发放卡
							current = card
						}
					});
					context.commit("setCardAllData", {...datas,current,cardNum:cardNum,actNo:params.cardActivityNo});
					if (cardNum.conflate > 0) {
						setTimeout(() => {
							actions.queryCardPrizeAsync(context, params)
						}, 200);
					}
					resolve(data);
				}
			})			
		})		

	},	
	setCardListDataAsync(context: any, data: object) {
		context.commit("setCardListData", data);
	},
	setLuckCardAllDataAsync(context: any, data: object) {
		context.commit("setLuckCardAllData", data);
	},		
	setIsShowPrizeAsync(context: any, bool: boolean) {
		context.commit("setIsShowPrize", bool);
	},
	setIsShowPrizeHistoryAsync(context: any, bool: boolean) {
		context.commit("setIsShowPrizeAsync", bool);
	},
	getPhoneAsync(context: any, data: any) {
		let domain = 'https://pub' + process.env.VUE_APP_URI_DOMAIN;
		let url = `${domain}/live/tv/liveLuck/checkLuckUserMobile?scene_id=${data.scene_id}`;
		fetch({
			url: url,
			method: "get"
		}).then((data: any) => {
			context.commit("setIsShowPhoneHint", data.ret);
		});
	},
	getCardAsync(context: any, data: any) {
		let callback = "getCard"
		let url = `https://service${process.env.VUE_APP_URI_DOMAIN}/act-assist/live-service/api/v1/room/cardActivity/user/getCard?sceneId=${data.sceneId}&cardNo=${data.actNo}`
		return new Promise((resolve, reject) => {		
			fetch({
				url: url,
				method: "get"
			}).then((res: any) => {
				resolve(res)
				console.log(res,555555);
				
				actions.getUserCardAsync(context, data)
			}).catch(err => {
				reject(err)
			});
		})
	},
	conflateCardAsync(context: any, params: any) {//卡片合成
		let callback = "conflateCard"
		let url = `//service${process.env.VUE_APP_URI_DOMAIN}/appact/goldenEgg/cardCombineLottery?cardActivityNo=${params.cardActivityNo}&ruleCode=${params.ruleCode}&channel=${params.channel}`
		return new Promise((resolve, reject) => {
			jsonp(url, {
				jsonp: "jsoncallback",
				jsoncallback: callback,
			}).then((data: any) => {
				console.log(data,'卡片合成');
				resolve(data);
				setTimeout(() => {
					actions.getUserCardAsync(context, params)
				}, 1500)
			}).catch((err: any) => {
				setTimeout(() => {
					actions.getUserCardAsync(context, params)
				}, 1500)				
				reject(err)
			})			
		})		
	},
	queryCardPrizeAsync(context: any, params: any) {//合成卡中奖查询
		let callback = "queryCardPrize"
		let url = `//service${process.env.VUE_APP_URI_DOMAIN}/appact/goldenEgg/queryCardLotteryRec?cardNo=${params.cardActivityNo}`
		return new Promise((resolve, reject) => {
			jsonp(url, {
				jsonp: "jsoncallback",
				jsoncallback: callback,
			}).then((data: any) => {
				if (data.code == '0000') {
					// resolve(data);
					actions.queryPrizeCouponAsync(context, {params,...data.content[0]})
				}
			})			
		})		
	},
	queryPrizeCouponAsync(context: any, params: any) {//合成卡中奖优惠券查询
		console.log('queryPrizeCouponAsync', params);
		
		let callback = "queryCardPrizeCoupon"
		let url = `//m${process.env.VUE_APP_URI_DOMAIN}/mobileact/ywsjAct/queryCouponByBatchId?batchIds=${params.batchId}&businessType=1,4&showChannelCode=activity&card=1&pageIndex=1&pageSize=10`
		return new Promise((resolve, reject) => {
			jsonp(url, {
				jsonp: "jsonCallback",
				jsonCallback: callback,
			}).then((data: any) => {
				// resolve(data);
				if (data.couponList && data.couponList.length > 0) {
					data.couponList.forEach((coupon: any) => {
						coupon = Object.assign(coupon, data.couponReceiveCountBatch[coupon.batchId]);
					});
					context.commit("setCardCoupon", {actNo:params.params.cardActivityNo,couponList:data.couponList});
				}
			}).catch(err => {
				reject(err);
			});			
		})		
	},
	setIsShowPhoneHintAsync(context: any, bool: boolean) {
		context.commit("setIsShowPhoneHint", bool);
	},
	setIsCardShowAsync(context: any, bool: boolean) {
		context.commit("setIsCardShow", bool);
	},
};

const mutations = {
	setHotGoodList(state: any, res: any) {
		state.hotGoodList = res;
	},
	setInsurance(state: any, res: any) {
		state.InsuranceGoods = res;
	},
	SetOpcRefresh(state: any, res: any) {
		state.opcRefreshData = res;
	},
	setRecommendGoods(state: any, res: any) {
		state.RecommendGoods = res;
	},
	setGoodsList(state: any, res: any) {
		state.goodsList = res;
	},
	setLuck(state: any, res: any) {
		if (res && res.id && res.id != state.luck.id) {
			state.isShowPrize = true;
		} else {
			state.isShowPrize = false;
		}
		state.luck = res;
	},
	setBessing(state: any, res: any) {
		state.bessingArr = res;
	},
	setLuckHistory(state: any, res: any) {
		state.luckHistory = res;
	},
	setCardAct(state: any, res: any) {
		if (!res) {
			return 
		}
		if (res.curCardActivity && res.curCardActivity.cardInfo && state.cardAllData) {
			if (state.cardAllData.cardNo != res.curCardActivity.cardInfo.cardNo) {
				state.cardAllData.cardNo = res.curCardActivity.cardInfo.cardNo;
			}
		} else {
			state.cardAllData.cardNo = '';
		}
			
		state.cardAct = res;
	},
	setLuckyCardAct(state: any, res: any) {//福卡
		if (!res || res.count <= 0) {
			return 
		}
		let cardObj = state.luckCardAllData.cardObj || {}
		if (res.list && res.list.length > 0) {
			res.list.forEach((card:any) => {
				if (cardObj[card.cardActivityNo]) {
					if (cardObj[card.cardActivityNo][card.roundId]) {
						cardObj[card.cardActivityNo][card.roundId].card = card;
					} else {
						cardObj[card.cardActivityNo][card.roundId] = {}
						cardObj[card.cardActivityNo][card.roundId].card = card;
					}
				} else {
					cardObj[card.cardActivityNo] = {};
					cardObj[card.cardActivityNo][card.roundId] = {}
					cardObj[card.cardActivityNo][card.roundId].card = card;
				}
			});
			if (!state.luckCardAct.time || state.luckCardAct.time < res.time) {
				state.luckCardAct = res.list[res.list.length - 1];
				state.luckCardAct.time = res.time;
				if (state.luckCardAllData.showListPop) {
					setTimeout(() => {
						state.luckCardAllData.updateListPop = true
					}, Math.random()*3000 );

				} else {
					state.luckCardAllData.showPop = true
				}
			}
			state.luckCardAllData.actNum = res.list.length
		} else { 
			state.luckCardAllData.showPop = false
		}
		state.luckCardAllData.cardObj = cardObj
		state.luckCardAllData.time = res.time;
		state.luckCardAllData.count = res.count;
	},
	setLuckCardAllData(state: any, res: any) {
		state.luckCardAllData[res.key] = res.value;
	},
	setCondition(state: any, res: any) {
		state.condition = res;
	},
	setCardListData(state: any, res: any) {
		state.cardListData = res;
	},
	setIsShowPrize(state: any, res: any) {
		state.isShowPrize = res;
	},
	setIsShowPrizeAsync(state: any, res: any) {
		state.isShowPrizeHistory = res;
	},
	setIsShowPhoneHint(state: any, res: any) {
		state.isShowPhoneHint = res;
	},
	setIsCardShow(state: any, res: any) {
		state.isCardShow = res;
	},
	setPlayBackFlag(state: any, res: any) {
		state.play_back_flag = res;
	},
	setRoomDetail(state: any, res: any) {
		state.roomData.proclamation = res.notice;
		state.coupons = res.coupons;
		state.auto_coupons = res.auto_coupons;
		state.patch_info = res.patch_info;
	},
	setFollow(state: any, res: any) {
		state.follow = res;
	},
	setBlessing(state: any, res: any) {
		state.blessingInfo = res.blessing_bag_info;
	},
	setYshLottery(state: any, res: any) {
		state.yshLottery = res;
	},
	setGoodsMaterial(state: any, res: any) {
		state.goodsMaterial = res;
	},
	setCardAllData(state: any, res: any) {
		if (res.current && res.current.cardNo) {
			state.cardAllData.cardNo = res.current.cardNo;
		} else if (state.cardAllData[res.actNo] && state.cardAllData[res.actNo].current && state.cardAllData[res.actNo].current.cardNo) {
			res.current = state.cardAllData[res.actNo].current;
		}
		console.log(res);
		state.cardAllData[res.actNo] = res;
	},
	setCardCoupon(state: any, res: any) {
		console.log(res);
		console.log(state.cardAllData);
		state.cardAllData[res.actNo].coupon = res.couponList;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
